import React from "react";
import { graphql } from "react-relay";

import { withFragmentContainer } from "coral-framework/lib/relay";

import { PianoConfigContainer_auth as AuthData } from "coral-admin/__generated__/PianoConfigContainer_auth.graphql";

import PianoConfig from "./PianoConfig";

interface Props {
  auth: AuthData;
  disabled?: boolean;
}

const PianoConfigContainer: React.FunctionComponent<Props> = ({
  disabled,
  auth,
}) => {
  return (
    <PianoConfig
      disabled={disabled}
      callbackURL={auth.integrations.piano.callbackURL}
    />
  );
};

const enhanced = withFragmentContainer<Props>({
  auth: graphql`
    fragment PianoConfigContainer_auth on Auth {
      integrations {
        piano {
          callbackURL
        }
      }
    }
  `,
})(PianoConfigContainer);

export default enhanced;
